import { FC } from "react";
import CONSTANTS from "../constants/constants.json";
import "./styles/page.css";

const { CREATOR_DATA } = CONSTANTS;

const ContentPage: FC = () => {
  return (
    <div className="page">
      <h1 className="page-name">{CREATOR_DATA.PAGE_TITLE}</h1>
      <p className="page-bio">{CREATOR_DATA.PAGE_BIO}</p>

      <section className="home-section home-section--tight">
        <div className="channel-list">
          {CREATOR_DATA.CHANNELS.map((channel) => (
            <div key={channel.ID} className="channel-item">
              <div className="channel-header">
                <span className="channel-name">{channel.HANDLE}</span>
                <span className="channel-status">{channel.STATUS}</span>
              </div>
              <p className="channel-tagline">{channel.TAGLINE}</p>
              <p className="channel-description">{channel.DESCRIPTION}</p>
              <div className="channel-topics">
                {channel.TOPICS.map((topic) => (
                  <span key={topic} className="channel-topic">
                    {topic}
                  </span>
                ))}
              </div>
              <div className="channel-links">
                {channel.LINKS.map((link) => (
                  <a
                    key={link.label}
                    href={link.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="channel-link"
                  >
                    {link.label}
                  </a>
                ))}
              </div>
            </div>
          ))}
        </div>
      </section>

      <div className="support-block">
        <p className="support-message">{CREATOR_DATA.SUPPORT.MESSAGE}</p>
        <a
          href={CREATOR_DATA.SUPPORT.URL}
          target="_blank"
          rel="noopener noreferrer"
          className="support-link"
        >
          {CREATOR_DATA.SUPPORT.LABEL}
        </a>
      </div>
    </div>
  );
};

export default ContentPage;
